module.exports = __webpack_public_path__ + "static/media/ISOS_banner_v4.539677e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ISOS_banner_v4.png
// module id = 315
// module chunks = 0